module.exports = __webpack_public_path__ + "assets/images/macaco_8eca1a2ccfbdab6fdea9e9bd42c7dd0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stage-helps/macaco.png
// module id = 303
// module chunks = 0